import React, {Component} from 'react';
import {DropdownItem, DropdownMenu, DropdownToggle, NavItem, NavLink, UncontrolledDropdown} from 'reactstrap';
import { Link } from 'react-router-dom';
import {ApplicationAuthPaths} from './authContstants';
import {LocationDescriptor} from 'history';
import {RootState} from 'app/rootReducer';
import {User} from 'oidc-client';
import {connect, ConnectedProps} from 'react-redux';

type Props = ConnectedProps<typeof connector>;

class LoginMenu extends Component<Props> {

    render() {
        const { isUserAuthenticated, username } = this.props;
        if (!isUserAuthenticated) {
            const loginPath = `${ApplicationAuthPaths.Login}`;
            return this.anonymousView(loginPath);
        } else {
            const profilePath = `${ApplicationAuthPaths.Profile}`;
            const logoutPath = { pathname: `${ApplicationAuthPaths.LogOut}`, state: { local: true } };
            return this.authenticatedView(username, profilePath, logoutPath);
        }
    }

    authenticatedView(userName: string | undefined, profilePath: LocationDescriptor, logoutPath: LocationDescriptor) {
        return (<>
            <UncontrolledDropdown nav inNavbar>
                <DropdownToggle nav caret className="text-dark">
                    {userName || 'Profile'}
                </DropdownToggle>
                <DropdownMenu right>
                    <DropdownItem tag={Link} className="text-dark" to={profilePath}>
                        Profile
                    </DropdownItem>
                    <DropdownItem tag={Link} className="text-dark" to={logoutPath}>
                        Logout
                    </DropdownItem>
                </DropdownMenu>
            </UncontrolledDropdown>
        </>);

    }

    anonymousView(loginPath: string) {
        return (<>
            <NavItem>
                <NavLink tag={Link} className="text-dark" to={loginPath}>Login</NavLink>
            </NavItem>
        </>);
    }
}

const mapStateToProps = (state: RootState) => {
    const user = state.oidc.user as User;
    return {
        isUserAuthenticated: user && !user.expired,
        username: user?.profile?.name
    };
};

const connector = connect(mapStateToProps);
export default connector(LoginMenu);
